// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";
import * as ActiveStorage from "@rails/activestorage";
import "channels";
import "controllers";

import Util from "./lib/util";
window.Util = Util;

import Ajax from "./lib/ajax";
window.Ajax = Ajax;

import Flash from "./lib/flash";
window.Flash = Flash;

import FlashV2 from "./lib/flash_v2";
window.FlashV2 = FlashV2;

import AdminFlash from "./lib/admin_flash";
window.AdminFlash = AdminFlash;

import Swal from "sweetalert2";
window.Swal = Swal;

Rails.start();
Turbolinks.start();
ActiveStorage.start();

// Metronic v7 self-initializes only on DOMContentLoaded, which Turbolinks does not
// re-fire on soft navigations (the admin layout swaps the body without a full reload).
// Without this, header/aside menus, dropdowns, tooltips, datatables, and uppy go dead
// after the first page. KTApp.init() alone is NOT enough — the layout behaviors live in
// separate KTLayout* initializers that must be replayed with their element ids (a no-arg
// call is a silent no-op). We deliberately do NOT re-execute scripts.bundle.js: it
// re-registers document-level delegated handlers every visit, so a single click would
// then toggle a menu twice.
const KT_LAYOUT_INITIALIZERS = [
  ["KTLayoutHeader", "kt_header", "kt_header_mobile"],
  ["KTLayoutHeaderMenu", "kt_header_menu", "kt_header_menu_wrapper"],
  ["KTLayoutHeaderTopbar", "kt_header_mobile_topbar_toggle"],
  ["KTLayoutAside", "kt_aside"],
  ["KTLayoutAsideToggle", "kt_aside_toggle"],
  ["KTLayoutAsideMenu", "kt_aside_menu"],
  ["KTLayoutSubheader", "kt_subheader"],
  ["KTLayoutContent", "kt_content"],
  ["KTLayoutScrolltop", "kt_scrolltop"],
];

const reinitializeMetronic = () => {
  // Metronic restores the aside-minimize state server-side only; re-apply it from the
  // cookie before the aside initializers run so a collapsed sidebar survives navigation.
  if (
    window.KTCookie &&
    window.KTCookie.getCookie("kt_aside_toggle_state") === "on"
  ) {
    document.body.classList.add("aside-minimize");
  }
  KT_LAYOUT_INITIALIZERS.forEach(([name, ...ids]) => {
    const layout = window[name];
    if (layout && typeof layout.init === "function") {
      try {
        layout.init(...ids);
      } catch {
        // one layout component failing must not abort the rest
      }
    }
  });
  if (window.KTApp && typeof window.KTApp.init === "function")
    window.KTApp.init();
  if (window.KTApp && typeof window.KTApp.initComponents === "function")
    window.KTApp.initComponents();
};

// turbolinks:visit only fires on real navigations, so the initial full load — where
// Metronic already self-initialized on DOMContentLoaded — is skipped (avoids double-bind).
let hasNavigated = false;
document.addEventListener("turbolinks:visit", () => {
  hasNavigated = true;
});
document.addEventListener("turbolinks:load", () => {
  if (hasNavigated) reinitializeMetronic();
});
